import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";
import { FinalCTASection } from "@/landing/sections/FinalCTASection";
import { FeaturesGrid } from "@/landing/sections/FeaturesGrid";
import { Footer } from "@/landing/sections/Footer";
import { Header } from "@/landing/sections/Header";
import { HeroSection } from "@/landing/sections/HeroSection";
import { HowItWorksSection } from "@/landing/sections/HowItWorksSection";
import { PrivacySection } from "@/landing/sections/PrivacySection";
import { ProblemSection } from "@/landing/sections/ProblemSection";
import { ScreenshotsSection } from "@/landing/sections/ScreenshotsSection";
import { UseCasesSection } from "@/landing/sections/UseCasesSection";
import { DocumentHead } from "@/seo/DocumentHead";

export function WasOKLanding() {
  const location = useLocation();
  const { messages } = useI18n();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    const timeoutId = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 80);
    return () => window.clearTimeout(timeoutId);
  }, [location.hash]);

  return (
    <div className="min-h-screen overflow-x-hidden bg-white">
      <DocumentHead
        title={messages.meta.title}
        description={messages.meta.description}
        path=""
      />
      <Header />
      <HeroSection />
      <ProblemSection />
      <HowItWorksSection />
      <PrivacySection />
      <FeaturesGrid />
      <UseCasesSection />
      <ScreenshotsSection />
      <FinalCTASection />
      <Footer />
    </div>
  );
}
